import { useState } from 'react';
import PayrollCalculator from './PayrollCalculator';
import PayrollRecordsList from './PayrollRecordsList';
import PayrollRecordDetail from './PayrollRecordDetail';

type View = { name: 'calculator' } | { name: 'list' } | { name: 'detail'; id: number };

export default function PayrollSection() {
  const [view, setView] = useState<View>({ name: 'calculator' });

  if (view.name === 'list') {
    return (
      <PayrollRecordsList
        onBack={() => setView({ name: 'calculator' })}
        onSelect={(id) => setView({ name: 'detail', id })}
      />
    );
  }

  if (view.name === 'detail') {
    return <PayrollRecordDetail id={view.id} onBack={() => setView({ name: 'list' })} />;
  }

  return <PayrollCalculator onShowRecordsList={() => setView({ name: 'list' })} />;
}
